module.exports = __webpack_public_path__ + "img/person.7dc2c31b.svg";